import { render, staticRenderFns } from "./Indexattend.vue?vue&type=template&id=3f1349fc&scoped=true&"
import script from "./Indexattend.vue?vue&type=script&lang=js&"
export * from "./Indexattend.vue?vue&type=script&lang=js&"
import style0 from "./Indexattend.vue?vue&type=style&index=0&id=3f1349fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1349fc",
  null
  
)

export default component.exports